import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import axiosInstance from "../../../axiosInstance";

const walletTabs = {
  corpus: {
    label: "Corpus Fund Wallet History",
    amountKey: "corpusFundAmount",
    percentKey: "corpusFundPercent",
  },
  driver: {
    label: "Driver Earning Wallet History",
    amountKey: "driverEarningAmount",
    percentKey: "driverEarningPercent",
  },
};

const AdminWalletHistory = () => {
  const [activeTab, setActiveTab] = useState("corpus");
  const [history, setHistory] = useState([]);
  const [wallets, setWallets] = useState({ corpusFund: 0, driverEarning: 0 });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `/admin/wallet-summary?page=${page}&limit=10`
        );
        setHistory(response.data.history || []);
        setWallets(response.data.wallets || { corpusFund: 0, driverEarning: 0 });
        setTotalPages(response.data.totalPages || 1);
      } catch (error) {
        console.error("Error fetching wallet history:", error);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [page]);

  const selectedWallet = walletTabs[activeTab];
  const formatDate = (date) =>
    date ? new Date(date).toLocaleString("en-IN") : "-";

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />
        <div className="py-4">
          <h1 className="h4 mb-0">Admin Wallet History</h1>
        </div>

        <div className="row">
          <div className="col-md-6 mb-4">
            <div className="card bg-info text-white border-0 shadow">
              <div className="card-body">
                <div className="small text-uppercase">Corpus Fund Wallet</div>
                <div className="h3 mb-0 mt-2">
                  ₹{Number(wallets.corpusFund || 0).toFixed(2)}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 mb-4">
            <div className="card bg-dark text-white border-0 shadow">
              <div className="card-body">
                <div className="small text-uppercase">Driver Earning Wallet</div>
                <div className="h3 mb-0 mt-2">
                  ₹{Number(wallets.driverEarning || 0).toFixed(2)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card border-0 shadow">
          <div className="card-header pb-0">
            <ul className="nav nav-tabs border-0">
              {Object.entries(walletTabs).map(([key, wallet]) => (
                <li className="nav-item" key={key}>
                  <button
                    type="button"
                    className={`nav-link ${activeTab === key ? "active" : ""}`}
                    onClick={() => setActiveTab(key)}
                  >
                    {wallet.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="table-responsive">
            <table className="table table-centered table-nowrap mb-0">
              <thead>
                <tr>
                  <th>Ride ID</th>
                  <th>Driver</th>
                  <th>Phone</th>
                  <th>Rate</th>
                  <th>Credit</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="6" className="text-center py-4">Loading...</td></tr>
                ) : history.length === 0 ? (
                  <tr><td colSpan="6" className="text-center py-4">No wallet history found</td></tr>
                ) : history.map((entry) => (
                  <tr key={`${activeTab}-${entry._id}`}>
                    <td>#{entry.orderId || "-"}</td>
                    <td>{entry.agentId?.username || "-"}</td>
                    <td>{entry.agentId?.phone || "-"}</td>
                    <td>{Number(entry[selectedWallet.percentKey] || 0)}%</td>
                    <td className="text-success fw-bold">
                      +₹{Number(entry[selectedWallet.amountKey] || 0).toFixed(2)}
                    </td>
                    <td>{formatDate(entry.endTime)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="card-footer d-flex justify-content-between align-items-center">
              <button className="btn btn-sm btn-gray-800" disabled={page === 1}
                onClick={() => setPage((value) => value - 1)}>Previous</button>
              <span>Page {page} of {totalPages}</span>
              <button className="btn btn-sm btn-gray-800" disabled={page === totalPages}
                onClick={() => setPage((value) => value + 1)}>Next</button>
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default AdminWalletHistory;
